const BUNDLE_PRODUCT = {
  productId: "8932640882857",
  handle: "dynamic-bundle",
  variantId: null,
  sellingPlan: null,
  deliveryType: "subscribe",
};

const PACK_TIERS = [6, 8, 12];
const MAX_ITEMS = 12;

const getEl = (id) => document.getElementById(id);

function getPackSizeFromVariant(variantRadio) {
  if (!variantRadio) return null;
  const variantId =
    variantRadio.getAttribute("data-variant-id") || variantRadio.value;
  const step = document.querySelector(`[data-step-variant="${variantId}"]`);
  const title =
    step?.querySelector(".progress-tracker__title")?.textContent || "";
  const match = title.match(/(\d+)\s*Pack/i);
  return match ? parseInt(match[1], 10) : null;
}

function getCurrentPackLimit() {
  const checked = getSelectedVariantRadio();
  return getPackSizeFromVariant(checked) || PACK_TIERS[0];
}

function findVariantForPackSize(packSize) {
  const radios = document.querySelectorAll(".variant-picker__radio");
  for (const radio of radios) {
    const size = getPackSizeFromVariant(radio);
    if (size === packSize) return radio;
  }
  return null;
}

function getNextTierForCount(count) {
  for (const tier of PACK_TIERS) {
    if (count <= tier) return tier;
  }
  return null;
}

function selectVariant(variantRadio) {
  if (!variantRadio || variantRadio.disabled) return false;
  variantRadio.checked = true;
  variantRadio.dispatchEvent(new Event("change", { bubbles: true }));
  return true;
}

function autoUpgradeVariantIfNeeded(newTotal) {
  const currentLimit = getCurrentPackLimit();

  if (newTotal <= currentLimit) return true;

  const nextTier = getNextTierForCount(newTotal);

  if (!nextTier) {
    showToast(`Maximum bundle size is ${MAX_ITEMS} items.`);
    return false;
  }

  const nextVariant = findVariantForPackSize(nextTier);
  if (nextVariant && !nextVariant.disabled) {
    selectVariant(nextVariant);
    return true;
  }

  showToast(`Cannot upgrade to ${nextTier} Pack - not available.`);
  return false;
}

function autoDowngradeVariantIfNeeded(newTotal) {
  const currentLimit = getCurrentPackLimit();

  const appropriateTier = getNextTierForCount(newTotal);

  if (!appropriateTier || appropriateTier >= currentLimit) return;

  const lowerVariant = findVariantForPackSize(appropriateTier);
  if (lowerVariant && !lowerVariant.disabled) {
    selectVariant(lowerVariant);
  }
}

function showToast(message, duration = 3000) {
  const existing = document.querySelector(".bundle-toast");
  if (existing) existing.remove();

  const toast = document.createElement("div");
  toast.className = "bundle-toast";
  toast.textContent = message;
  document.body.appendChild(toast);

  requestAnimationFrame(() => {
    toast.classList.add("is-visible");
  });

  setTimeout(() => {
    toast.classList.remove("is-visible");
    setTimeout(() => toast.remove(), 300);
  }, duration);
}

const getCartAddUrl = () => `${window.Shopify?.routes?.root || "/"}cart/add.js`;

async function addBundleToCart({ bundleProduct, selections }) {
  if (!window.recharge?.bundle?.getDynamicBundleItems) {
    throw new Error(
      "Recharge bundle API not found (recharge.bundle.getDynamicBundleItems).",
    );
  }

  const isSubscribe = bundleProduct.deliveryType === "subscribe";

  // Get the selected interval name from the main dropdown
  const panelSelect = document.querySelector("[data-bundle-selling-plan]");
  const selectedPlanName = panelSelect
    ? panelSelect.options[panelSelect.selectedIndex]?.textContent?.trim() || ""
    : "";

  const bundleSelections = selections.map((sel) => {
    const entry = {
      collectionId: sel.collectionId,
      externalProductId: sel.externalProductId,
      externalVariantId: sel.externalVariantId,
      quantity: sel.quantity,
    };
    if (isSubscribe && sel.sellingPlans?.length) {
      // Match by name against the selected interval
      const match = sel.sellingPlans.find((sp) => sp.name === selectedPlanName);
      const plan = match || sel.sellingPlans[0];
      entry.sellingPlan = plan.id;
    }
    return entry;
  });

  const bundle = {
    externalVariantId: String(bundleProduct.variantId),
    externalProductId: String(bundleProduct.productId),
    selections: bundleSelections,
  };

  const cartItems = await recharge.bundle.getDynamicBundleItems(
    bundle,
    bundleProduct.handle,
  );

  const res = await fetch(getCartAddUrl(), {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ items: cartItems }),
  });

  if (!res.ok) {
    let body = "";
    try {
      body = await res.text();
    } catch {}
    throw new Error(`Request failed (${res.status} ${res.statusText}) ${body}`);
  }

  return res.json();
}

function setBundleVariantId(variantId) {
  BUNDLE_PRODUCT.variantId = variantId ? String(variantId) : null;
}

function setBundleSellingPlanId(planId) {
  const n = parseInt(planId, 10);
  BUNDLE_PRODUCT.sellingPlan = Number.isFinite(n) ? n : null;
}

function setBundleDeliveryType(type) {
  BUNDLE_PRODUCT.deliveryType = type === "onetime" ? "onetime" : "subscribe";
}

function getSelectedVariantRadio() {
  return document.querySelector(".variant-picker__radio:checked") || null;
}

function updateHighlightVisibility(variantId) {
  const highlights = document.querySelectorAll("[data-highlight-variant]");
  highlights.forEach((el) => {
    const elVariantId = el.getAttribute("data-highlight-variant");
    el.hidden = elVariantId !== variantId;
  });
}

function getSelectedVariantId() {
  const checked = getSelectedVariantRadio();
  return checked
    ? checked.getAttribute("data-variant-id") || checked.value
    : null;
}

function formatMoney(cents) {
  return "$" + (cents / 100).toFixed(2);
}

function getSelectionsTotalPrice() {
  let total = 0;
  selectionMap.forEach((sel) => {
    total += (sel.price || 0) * sel.quantity;
  });
  return total;
}

function getSelectionsComparePrice() {
  let total = 0;
  selectionMap.forEach((sel) => {
    total += (sel.comparePrice || sel.price || 0) * sel.quantity;
  });
  return total;
}

const TIER_DISCOUNTS = { 6: 5.0, 8: 10.0, 12: 15.0 };

function getDiscountForCount(count) {
  let discount = 0;
  for (const tier of PACK_TIERS) {
    if (count >= tier && TIER_DISCOUNTS[tier]) {
      discount = TIER_DISCOUNTS[tier];
    }
  }
  return discount;
}

function setPanelPrice() {
  const priceEl = document.querySelector("[data-bundle-price]");
  const compareEl = document.querySelector("[data-bundle-compare-price]");
  const badgeEl = document.querySelector("[data-bundle-save-badge]");

  let totalCount = 0;
  let totalPrice = 0;
  let finalPrice = 0;
  console.log("getTotalSelectedCount: ", getTotalSelectedCount());
  const tierDiscount = getDiscountForCount(getTotalSelectedCount());
  console.log("tierDiscount: ", tierDiscount);
  const subscribeDiscount =
    BUNDLE_PRODUCT.deliveryType === "subscribe" ? 10 : 0;

  selectionMap.forEach((sel) => {
    totalCount += sel.quantity;
    const itemCents = sel.price || 0;
    totalPrice += itemCents * sel.quantity;
    let unitCents = itemCents;
    if (subscribeDiscount > 0) {
      unitCents = Math.floor(unitCents * (100 - subscribeDiscount) / 100);
    }
    if (tierDiscount > 0) {
      unitCents -= Math.floor(unitCents * tierDiscount / 100);
    }
    finalPrice += unitCents * sel.quantity;
  });

  if (totalCount === 0) {
    if (priceEl) priceEl.textContent = "$0.00";
    if (compareEl) {
      compareEl.textContent = "";
      compareEl.style.display = "none";
    }
    if (badgeEl) {
      badgeEl.textContent = "";
      badgeEl.style.display = "none";
    }
    return;
  }

  const totalDiscount = tierDiscount + subscribeDiscount;
  const hasDiscount = totalDiscount > 0;

  if (hasDiscount) {
    if (priceEl) priceEl.textContent = formatMoney(finalPrice);
    if (compareEl) {
      compareEl.textContent = formatMoney(totalPrice);
      compareEl.style.display = "inline";
    }
    if (badgeEl) {
      badgeEl.textContent = `${totalDiscount}% OFF`;
      badgeEl.style.display = "inline-block";
    }
  } else {
    if (priceEl) priceEl.textContent = formatMoney(totalPrice);
    if (compareEl) {
      compareEl.textContent = "";
      compareEl.style.display = "none";
    }
    if (badgeEl) {
      badgeEl.textContent = "";
      badgeEl.style.display = "none";
    }
  }
}

function getHiddenVariantPlanSelect(variantId) {
  return document.querySelector(
    `[data-selling-plan-select][data-variant="${variantId}"]`,
  );
}

function populatePanelPlanDropdown(variantId) {
  const panelSelect = document.querySelector("[data-bundle-selling-plan]");
  if (!panelSelect) return;

  const sourceSelect = getHiddenVariantPlanSelect(variantId);

  panelSelect.innerHTML = "";

  if (!sourceSelect || !sourceSelect.options.length) {
    panelSelect.disabled = true;
    setBundleSellingPlanId(null);
    return;
  }

  panelSelect.disabled = false;

  Array.from(sourceSelect.options).forEach((opt, idx) => {
    const o = document.createElement("option");
    o.value = opt.value;
    o.textContent = opt.textContent;
    if (idx === 0) o.selected = true;
    panelSelect.appendChild(o);
  });

  setBundleSellingPlanId(panelSelect.value);
}

function updateProgressTracker() {
  const dots = document.querySelectorAll("[data-step-dot]");
  const fill = document.querySelector("[data-progress-fill]");

  if (!dots.length || !fill) return;

  const totalCount = getTotalSelectedCount();
  let reachedIndex = -1;

  dots.forEach((dot, i) => {
    const step = dot.closest(".progress-tracker__step");
    const variantId = dot.getAttribute("data-step-dot");
    const radio = document.querySelector(
      `.variant-picker__radio[data-variant-id="${variantId}"]`,
    );
    const packSize = getPackSizeFromVariant(radio);

    dot.classList.remove("is-active", "is-reached");
    step.classList.remove("is-active");

    if (packSize && totalCount >= packSize) {
      reachedIndex = i;
    }
  });

  dots.forEach((dot, i) => {
    const step = dot.closest(".progress-tracker__step");
    if (i < reachedIndex) {
      dot.classList.add("is-reached");
    } else if (i === reachedIndex) {
      dot.classList.add("is-active");
      step.classList.add("is-active");
    }
  });

  const totalSteps = dots.length;
  if (reachedIndex < 0) {
    fill.style.width = "0%";
  } else {
    const fillPercent = (reachedIndex / (totalSteps - 1)) * 100;
    fill.style.width = fillPercent + "%";
  }
}

function initVariantAndPlanPicker() {
  const firstVariantId = getSelectedVariantId();
  if (firstVariantId) {
    setBundleVariantId(firstVariantId);
    setPanelPrice();
    populatePanelPlanDropdown(firstVariantId);
    updateProgressTracker();
  }

  // Bind progress tracker dot clicks
  const dots = document.querySelectorAll("[data-step-dot]");
  dots.forEach((dot) => {
    dot.addEventListener("click", () => {
      const variantId = dot.getAttribute("data-step-dot");
      const radio = document.querySelector(
        `.variant-picker__radio[data-variant-id="${variantId}"]`,
      );
      if (radio && !radio.disabled) {
        radio.checked = true;
        radio.dispatchEvent(new Event("change", { bubbles: true }));
      }
    });
  });

  const picker = document.querySelector(".variant-picker");
  if (picker) {
    picker.addEventListener("change", (e) => {
      const t = e.target;
      if (!t || !t.matches(".variant-picker__radio")) return;

      const variantId = t.getAttribute("data-variant-id") || t.value;

      updateHighlightVisibility(variantId);
      setBundleVariantId(variantId);
      populatePanelPlanDropdown(variantId);
      updateProgressTracker();
      updateUI();
    });
  }

  const panelSelect = document.querySelector("[data-bundle-selling-plan]");
  const subscribeRadio = document.querySelector(
    '[data-delivery-type="subscribe"]',
  );

  if (panelSelect) {
    panelSelect.addEventListener("change", () => {
      setBundleSellingPlanId(panelSelect.value);
      if (subscribeRadio && !subscribeRadio.checked) {
        subscribeRadio.checked = true;
        setBundleDeliveryType("subscribe");
        setPanelPrice();
      }
    });

    panelSelect.addEventListener("focus", () => {
      if (subscribeRadio && !subscribeRadio.checked) {
        subscribeRadio.checked = true;
        setBundleDeliveryType("subscribe");
        setPanelPrice();
      }
    });

    panelSelect.addEventListener("click", () => {
      if (subscribeRadio && !subscribeRadio.checked) {
        subscribeRadio.checked = true;
        setBundleDeliveryType("subscribe");
        setPanelPrice();
      }
    });
  }

  const deliveryRadios = document.querySelectorAll(".delivery-options__radio");
  deliveryRadios.forEach((radio) => {
    radio.addEventListener("change", () => {
      const type = radio.getAttribute("data-delivery-type");
      setBundleDeliveryType(type);
      setPanelPrice();
    });
  });

  const checkedDelivery = document.querySelector(
    ".delivery-options__radio:checked",
  );
  if (checkedDelivery) {
    setBundleDeliveryType(checkedDelivery.getAttribute("data-delivery-type"));
  }
}

const selectionMap = new Map();

function keyFor(variantId) {
  return String(variantId);
}

function clampQty(n) {
  const x = parseInt(n, 10);
  if (!Number.isFinite(x) || x < 1) return 1;
  return x;
}

function addToSelections({
  collectionId,
  externalProductId,
  externalVariantId,
  quantity,
  image,
  price,
  comparePrice,
  inventoryLevel,
  sellingPlans,
}) {
  const key = keyFor(externalVariantId);
  const qty = clampQty(quantity);
  const currentTotal = getTotalSelectedCount();
  const newTotal = currentTotal + qty;

  const existing = selectionMap.get(key);
  const currentQty = existing?.quantity || 0;
  const newQty = currentQty + qty;
  const maxInventory =
    inventoryLevel !== null &&
    inventoryLevel !== undefined &&
    inventoryLevel > 0
      ? inventoryLevel
      : Infinity;

  if (newQty > maxInventory) {
    if (maxInventory <= 0) {
      showToast("Sorry, this item is out of stock.");
    } else {
      showToast(`Sorry, only ${maxInventory} of this item left in stock.`);
    }
    return false;
  }

  if (newTotal > MAX_ITEMS) {
    showToast(`Maximum bundle size is ${MAX_ITEMS} items.`);
    return false;
  }

  if (!autoUpgradeVariantIfNeeded(newTotal)) {
    return false;
  }

  if (existing) {
    existing.quantity += qty;
    selectionMap.set(key, existing);
  } else {
    selectionMap.set(key, {
      collectionId: String(collectionId),
      externalProductId: String(externalProductId),
      externalVariantId: String(externalVariantId),
      quantity: qty,
      image: image || "",
      price: price || 0,
      comparePrice: comparePrice || price || 0,
      sellingPlans: sellingPlans || [],
    });
  }
  return true;
}

function removeFromSelections(externalVariantId) {
  const key = keyFor(externalVariantId);
  const existing = selectionMap.get(key);
  if (!existing) return;

  existing.quantity -= 1;
  if (existing.quantity <= 0) {
    selectionMap.delete(key);
  } else {
    selectionMap.set(key, existing);
  }

  const newTotal = getTotalSelectedCount();
  autoDowngradeVariantIfNeeded(newTotal);
}

function getSelectionsArray() {
  return Array.from(selectionMap.values()).map((sel) => ({
    collectionId: sel.collectionId,
    externalProductId: sel.externalProductId,
    externalVariantId: sel.externalVariantId,
    quantity: sel.quantity,
    sellingPlans: sel.sellingPlans,
  }));
}

function getSelectionsArrayFull() {
  return Array.from(selectionMap.values());
}

function getTotalSelectedCount() {
  let total = 0;
  selectionMap.forEach((v) => (total += v.quantity));
  return total;
}

function updateCardButton(cardEl, externalVariantId) {
  const sel = selectionMap.get(keyFor(externalVariantId));
  const qty = sel?.quantity || 0;
  const btn = cardEl.querySelector("[data-bundle-btn]");
  const qtyDisplay = cardEl.querySelector("[data-bundle-qty]");

  if (!btn) return;

  if (qty > 0) {
    btn.classList.add("is-active");
    if (qtyDisplay) qtyDisplay.textContent = String(qty);
  } else {
    btn.classList.remove("is-active");
    if (qtyDisplay) qtyDisplay.textContent = "0";
  }
}

function removeSelectionCompletely(externalVariantId) {
  const key = keyFor(externalVariantId);
  selectionMap.delete(key);

  const newTotal = getTotalSelectedCount();
  autoDowngradeVariantIfNeeded(newTotal);

  const card = document.querySelector(
    `[data-bundle-product][data-external-variant-id="${externalVariantId}"]`,
  );
  if (card) {
    updateCardButton(card, externalVariantId);
  }
}

function updateUI() {
  setPanelPrice();
  updateProgressTracker();
}

function bindAddToCartButton(buttonId) {
  const btn = getEl(buttonId);
  if (!btn) return;

  btn.addEventListener("click", async () => {
    try {
      btn.disabled = true;

      const selections = getSelectionsArray();
      if (!selections.length) {
        showToast("Add at least one item to the bundle first.");
        return;
      }

      if (!BUNDLE_PRODUCT.variantId) {
        showToast("Please choose a bundle variant first.");
        return;
      }

      const totalCount = getTotalSelectedCount();
      const packLimit = getCurrentPackLimit();
      if (totalCount !== packLimit) {
        showToast(
          `Please select exactly ${packLimit} items for your ${packLimit} Pack.`,
        );
        return;
      }

      if (
        BUNDLE_PRODUCT.deliveryType === "subscribe" &&
        !BUNDLE_PRODUCT.sellingPlan
      ) {
        showToast("Please choose a delivery interval first.");
        return;
      }

      await addBundleToCart({
        bundleProduct: BUNDLE_PRODUCT,
        selections,
      });

      document.dispatchEvent(
        new CustomEvent("dispatch:cart-drawer:refresh", {
          bubbles: true,
        }),
      );

      setTimeout(() => {
        document.dispatchEvent(new CustomEvent("dispatch:cart-drawer:open"));
      }, 300);
    } catch (err) {
      console.error(err);
      showToast("Sorry—something went wrong adding this bundle to your cart.");
    } finally {
      btn.disabled = false;
    }
  });
}

function initBundleBuilder() {
  initVariantAndPlanPicker();

  const cards = document.querySelectorAll("[data-bundle-product]");
  if (!cards.length) return;

  cards.forEach((card) => {
    const btn = card.querySelector("[data-bundle-btn]");
    const minusEl = card.querySelector("[data-bundle-minus]");
    const plusEl = card.querySelector("[data-bundle-plus]");

    const collectionId = card.getAttribute("data-collection-id");
    const externalProductId = card.getAttribute("data-external-product-id");
    const externalVariantId = card.getAttribute("data-external-variant-id");
    const image = card.getAttribute("data-image") || "";
    const price = parseInt(card.getAttribute("data-price"), 10) || 0;
    const comparePrice =
      parseInt(card.getAttribute("data-compare-price"), 10) || price;
    const invAttr = card.getAttribute("data-inventory-level");
    const inventoryLevel = invAttr !== null ? parseInt(invAttr, 10) : null;
    let sellingPlans = [];
    try {
      sellingPlans = JSON.parse(
        card.getAttribute("data-selling-plans") || "[]",
      );
    } catch {}

    if (!btn || !collectionId || !externalProductId || !externalVariantId)
      return;

    updateCardButton(card, externalVariantId);

    btn.addEventListener("click", (e) => {
      if (
        e.target.closest("[data-bundle-minus]") ||
        e.target.closest("[data-bundle-plus]")
      ) {
        return;
      }

      if (!btn.classList.contains("is-active")) {
        const added = addToSelections({
          collectionId,
          externalProductId,
          externalVariantId,
          quantity: 1,
          image,
          price,
          comparePrice,
          inventoryLevel,
          sellingPlans,
        });
        if (added) {
          updateCardButton(card, externalVariantId);
          updateUI();
        }
      }
    });

    if (plusEl) {
      plusEl.addEventListener("click", (e) => {
        e.stopPropagation();
        const added = addToSelections({
          collectionId,
          externalProductId,
          externalVariantId,
          quantity: 1,
          image,
          price,
          comparePrice,
          inventoryLevel,
          sellingPlans,
        });
        if (added) {
          updateCardButton(card, externalVariantId);
          updateUI();
        }
      });
    }

    if (minusEl) {
      minusEl.addEventListener("click", (e) => {
        e.stopPropagation();
        removeFromSelections(externalVariantId);
        updateCardButton(card, externalVariantId);
        updateUI();
      });
    }
  });

  updateUI();
  bindAddToCartButton("addToCart");
  initScrollHint();
}

function initScrollHint() {
  const list = document.querySelector("[data-bundle-grid]");
  const hint = document.querySelector("[data-scroll-hint]");
  if (!list || !hint) return;

  function checkScroll() {
    const atBottom = list.scrollHeight - list.scrollTop - list.clientHeight < 2;
    hint.classList.toggle("is-hidden", atBottom);
  }

  list.addEventListener("scroll", checkScroll, { passive: true });
  checkScroll();
}

document.addEventListener("DOMContentLoaded", initBundleBuilder);
